module.exports = __webpack_public_path__ + "static/media/logo-text-only.98258d26.svg";